<script>
  import { tweened } from "svelte/motion";
  import { muted, audioEl, audioCtx, audioActive } from "../stores/global.js";

  const MAX = 0.1;
  const volumeTween = tweened(0, { duration: 1000 });
  let el;

  export const start = () => {
    el.volume = 0;
    el.play();
    // $audioEl = el;
    $audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    volumeTween.set(MAX);
  };

  $: if (el) el.volume = $volumeTween;
  $: volumeTween.set($muted || $audioActive ? 0 : MAX);
</script>

<audio src="assets/audio/bg.mp3" bind:this="{el}" preload loop></audio>
